import React from "react";
import { NewModal } from "../uiMerge/newModal";
import { QrCode } from "../shared/QrCode";
import { useFindBaseUrl } from "@njoy/controller";

type MerhcantInfoModalProps = {
  visible: boolean;
  onCancel: () => void;
  njoyCode: string;
};

const QrCodeModal: React.FC<MerhcantInfoModalProps> = ({
  visible,
  onCancel,
  njoyCode,
}: MerhcantInfoModalProps) => {
  const { baseUrl, loading } = useFindBaseUrl();
  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[335px]"
      heightClass="min-h-[255px]"
      position="start"
      showCloseButton
      onClose={onCancel}
    >
      <div className="flex flex-col bg-white  mt-16 items-center py-6 mb-6 mx-6 rounded-md ">
        {loading ? (
          "..."
        ) : (
          <QrCode
            value={`${baseUrl}/validation-portal/validate/${njoyCode}`}
            size={250}
          />
        )}
      </div>
    </NewModal>
  );
};

export default QrCodeModal;
